import React, { useState, useEffect } from 'react';
import customToast from '../../../components/common/basic/Toast';
import LoadingSpinner from '../../../revampComponents/Atom/Loading';
import DragDropTable from '../../../revampComponents/Atom/Table/DragDropTable';

const TaskCategoryTable = ({
    data = [],
    isLoading = false,
    onEdit = () => {},
    onDelete = () => {},
    onReorder = () => {},
}) => {
    const [rowData, setRowData] = useState([]);
    const columns = ["Category", "Quick Actions"];

    useEffect(() => {
        const formattedData = data
            ?.map((item) => ({
                id: item?.category_id,
                name: item?.category_name,
                categoryOrder: item?.category_order,
                originalData: item 
            }))
            ?.sort((a, b) => a?.categoryOrder - b?.categoryOrder);
        setRowData(formattedData);
    }, [data]);

    const handleDragEnd = async (e) => {
        if (!e?.destination) return;

        const tempData = Array.from(rowData);
        const [sourceData] = tempData?.splice(e?.source?.index, 1);
        tempData?.splice(e?.destination?.index, 0, sourceData);

        // Update order
        tempData.forEach((item, index) => {
            item.categoryOrder = index + 1;
        });

        setRowData(tempData);

        if (onReorder) {
            try {
                await onReorder(tempData);
                customToast.success("Categories reordered successfully.");
            } catch (error) {
                customToast.error(error?.response?.data?.message || "Failed to reorder categories.");
                // Revert on error
                const originalData = data
                    ?.map((item) => ({
                        id: item?.category_id,
                        name: item?.category_name,
                        categoryOrder: item?.category_order,
                        originalData: item
                    }))
                    ?.sort((a, b) => a?.categoryOrder - b?.categoryOrder);
                setRowData(originalData);
            }
        }
    };

    const handleEdit = (category) => {
        if (onEdit) {
            onEdit(category?.originalData);
        }
    };

    const handleDelete = (category) => {
        if (onDelete) {
            onDelete(category?.id);
        }
    };

    // Helper functions for the generic table
    const getItemId = (item) => item?.id;
    const getItemDisplayValue = (item) => item?.name;

    return (
        <div className="mt-2 w-100">
            {isLoading ? (
                <div className="m-auto d-flex align-items-center mt-5 richtext-mt-10 multi-loader-spinner">
                    <LoadingSpinner />
                </div>
            ) : (
                <DragDropTable
                    handleDragEnd={handleDragEnd}
                    columns={columns}
                    rowData={rowData}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    getItemId={getItemId}
                    getItemDisplayValue={getItemDisplayValue}
                    droppableId="droppable-categories"
                    keyPrefix="category"
                />
            )}

            <style jsx>{`
                .multi-loader-spinner {
                    margin-top: 110px !important;
                }
            `}</style>
        </div>
    );
};

export default TaskCategoryTable;
